<template>
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
    <p class="message"  
      :style="{ 
          'background': speaker==='my' ? color.balloonMy : color.balloonOtr + '!important', 
          'color': autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
          'filter': shadowStyle(color.shadowType)}">
    回答を記録しました
    </p>
  </div>
</template>

<script>
import hex2rgb from "@/functions/hex2rgb"
// 外部関数
import {
  autoColor,
  shadowStyle
} from "@/functions/balloonFunc"

export default {
  name: "OutputParts",
  props: ['message', 'speaker', 'color', 'filename', 'files'],
  methods: {
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    }
  },
  computed: {
  },
  data () {
    return {
      isError: true
    }
  }
};
</script>

<style scoped>
.message {
  text-align: left;
  padding: 16px;
  width: auto;
  max-width: -webkit-fill-available;
  word-wrap: break-word;
  border-radius: 8px;
  font-size: smaller;
  white-space: pre-wrap;
  transition: 0.7s;
}
.my-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/OutputParts.vue